module.exports = __webpack_public_path__ + "Bild_3.37db9736c69509173667df55cbd89bd5.png";